<template>
  <div class="orders-by-quarter-chart">
    <apexchart
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'OrdersByQuarterChart',
  props: {
    data: {
      type: Array,
      required: true,
    },
    showValue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: 350,
          stacked: false,
          toolbar: {
            show: true,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        xaxis: {
          categories: this.categories,
        },
        yaxis: {
          title: {
            text: this.showValue ? 'Total Value ($)' : '# of Orders',
          },
          labels: {
            formatter: (value) => {
              if (this.showValue) {
                return '$' + (value / 1000).toFixed(0) + 'k'
              }
              return Math.round(value)
            },
          },
        },
        fill: {
          opacity: 1,
        },
        colors: ['#5c11a2'],
        tooltip: {
          y: {
            formatter: (val) => {
              if (this.showValue) {
                return '$' + val.toLocaleString()
              }
              return val + ' orders'
            },
          },
        },
      }
    },
    categories() {
      return _.map(this.data, (d) => {
        return `Q${d._id.quarter} ${d._id.year}`
      })
    },
    series() {
      const values = _.map(this.data, (d) => {
        return this.showValue ? d.totalValue || 0 : d.count
      })

      return [
        {
          name: this.showValue ? 'Total Value' : 'Orders',
          data: values,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped></style>



